module.exports = __webpack_public_path__ + "static/media/punggol-back.8d0aa661.png";